<template>
    <header
        class="BaseHeading"
        :class="classes"
    >
        <em
            v-if="preheading">
            {{ preheading }}
        </em>

        <HeadingElement
            v-if="tag"
            :tag="tag"
            v-html="heading"
        />

        <hgroup
            v-else
            v-html="heading"
        />
    </header>
</template>
<script>

const HeadingElement =  {
    name: 'HeadingElement',
    render(createElement) {
        return createElement(
            this.tag,
            this.$slots.default
        );
    },
    props: {
        tag: {
            type: String,
            required: true,
        },
    },
}


export default {
    name: 'BaseHeading',
    components: {
        HeadingElement
    },
    props: {
        heading: {
            type: String,
            default: null
        },
        preheading: {
            type: String,
            default: null
        },
        tag: {
            type: String,
            default: null,
        },
        classes: {
            default: null,
        },
    }
}
</script>
<style lang="scss">
    .BaseHeading {
        color: getColor('black');

        h2 {
            font-family: $heading-font-family;
            font-size: 2.25rem;
            line-height: 1.285714285714286;
            margin-bottom: getSpacing('medium');
            text-transform: uppercase;
            word-break: break-word;

            @include media-query(desk) {
                font-size: 2.8rem;
                line-height: 1.272727272727273;
                margin-bottom: 2.75rem;
                word-break: normal;
            }
        }

        h1 {
            font-size: 2.625rem;
            line-height: 0.8;
            font-family: $heading-font-family;
            text-transform: uppercase;

            @include media-query(desk) {
                font-size: 4rem;
            }
        }

        h3 {
            font-family: $heading-font-family;
            font-size: 2rem;
            line-height: 1.333333333333333;
            margin-bottom: getSpacing('spacer');
            text-transform: uppercase;

            @include media-query(desk) {
                font-size: 2.4rem;
                line-height: 1.263157894736842;
                margin-bottom: getSpacing('medium');
            }
        }

        em {
            display: block;
            font-family: $fancy-font-family;
            font-weight: 400;
            font-size: 1.875rem;
            line-height: 1;
            text-transform: none;
            font-style: normal;

            @include media-query(desk) {
                font-size: 2.4rem;
            }
        }

        &.noline {
            h1, h2, h3 {
                line-height: 0.9!important;
            }
        }
    }

    .AlgoliaSearchHeader .BaseHeading em {
        @include media-query(desk) {
            font-size: 2rem;
        }
    }
</style>
<style lang="scss" scoped>

    .BaseHeading {
        color: getColor('black');
    }

    .BaseHeading--fancy {
        display: flex;
        align-items: flex-end;
        margin-bottom: getSpacing('medium');

        em {
            max-width: 330px;
            font-size: 1.8rem;
            line-height: 0.5;
        }

        &:after {
            content: '';
            flex-grow: 1;
            display: block;
            height: 1px;
            margin-left: getSpacing('small');
            background-color: getColour('grey', 'medium');
        }
    }

    h1, h2, h3, h4, h5, h6 {
        font-family: $heading-font-family;
        text-transform: uppercase;

        .noline & {
            line-height: 0.9!important;
        }
    }

    h1 {
        font-size: 2.625rem;
        line-height: 0.8;

        @include media-query(desk) {
            font-size: 4rem;
        }
    }

    .h2, h2 {
        font-size: 2.25rem;
        line-height: 1.285714285714286;

        @include media-query(desk) {
            font-size: 2.8rem;
            line-height: 1.272727272727273;
        }
    }

    .h3, h3 {
        font-size: 2rem;
        line-height: 1.333333333333333;

        @include media-query(desk) {
            font-size: 2.4rem;
            line-height: 1.263157894736842;
        }
    }

    em {
        display: block;
        font-family: $fancy-font-family;
        font-weight: 400;
        font-size: 1.875rem;
        line-height: 1;
        text-transform: none;
        font-style: normal;

        @include media-query(desk) {
            font-size: 2.4rem;
        }

        .h5 & {
            font-size: 1.45rem;

            @include media-query(desk) {
                font-size: 1.65rem;
            }
        }

        .h6 & {
            font-size: 1.25rem;

            @include media-query(desk) {
                font-size: 1.4rem;
            }
        }
    }

    .h6, h6 {
        font-size: 1.15rem;
        line-height: 1.2;

        @include media-query(desk) {
            font-size: 1.4rem;
            line-height: 1.285714285714286;
        }
    }

    h4, .h4 {
        font-size: 1.75rem;
        line-height: 1.4;

        @include media-query(desk) {
            font-size: 2.1rem;
            line-height: 1.235294117647059;
        }
    }

    h5, .h5 {
        font-size: 1.5rem;
        line-height: 1.2;

        @include media-query(desk) {
            font-size: 1.8rem;
            line-height: 1.285714285714286;
        }

        .h7 & {
            font-size: 1rem!important;
            line-height: 1.2;
        }
    }
</style>
